import TemplateContents from './TemplateContents';
import CommonCarousel from './CommonCarousel';
import { gsap } from 'gsap';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
    this.initCircleAnimations();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  setVars() {
    super.setVars();
    this.carousels = [];
    this.circleColors = ['#E65080', '#EF8DA5', '#E2C3A6'];
    this.circleAnimations = [];
  }

  setDom() {
    super.setDom();
    this.section4Dom = document.querySelector('main.top .section4');
    const carouselElements = document.querySelectorAll('.section4 .c_chunk');
    carouselElements.forEach((el) => {
      this.carousels.push(
        new CommonCarousel(el, {
          itemSelector: '.c_carousel_item',
        }),
      );
    });

    this.chunk8Text = document.querySelector('main.top .section4 .chunk8 .content .tit');
    this.chunk8TextItemAll = document.querySelectorAll('main.top .section4 .chunk8 .content .tit .item');
    this.chunk8TextItemChildAll = document.querySelectorAll('main.top .section4 .chunk8 .content .tit .item .item_child');
    this.chunk8TextItemCircleAll = document.querySelectorAll('main.top .section4 .chunk8 .content .tit .item .item_circle');

    this.pack.initRandomPop(
      this.chunk8TextItemAll,
      this.chunk8TextItemCircleAll,
      this.chunk8TextItemChildAll,
      this.circleColors
    );


    this.chunk8Text2 = document.querySelector('main.top .section4 .chunk8 .text');

    this.bgCircles = [
      document.querySelector('main.top .section4 .circle1'),
      document.querySelector('main.top .section4 .circle2'),
      document.querySelector('main.top .section4 .circle3'),
      document.querySelector('main.top .section4 .circle4'),
    ];
  }

  destruct() {
    super.destruct();
    if (this.carousels) {
      this.carousels.forEach((carousel) => carousel.destruct());
    }
    if (this.circleAnimations) {
      this.circleAnimations.forEach((obj) => obj.tween.kill());
    }
  }

  initCircleAnimations() {
    const mag = 30; // rem
    this.bgCircles.forEach((circle) => {
      if (!circle) return;
      const tween = gsap
        .timeline({
          repeat: -1,
          yoyo: true,
          paused: true,
        })
        .to(circle, {
          x: () => `${this.pack.random(-mag, mag)}rem`,
          y: () => `${this.pack.random(-mag, mag)}rem`,
          duration: 7,
          ease: 'sine.inOut',
        })
        .to(circle, {
          x: () => `${this.pack.random(-mag, mag)}rem`,
          y: () => `${this.pack.random(-mag, mag)}rem`,
          duration: 8,
          ease: 'sine.inOut',
        })
        .to(circle, {
          x: 0,
          y: 0,
          duration: 9,
          ease: 'sine.inOut',
        });

      this.circleAnimations.push({ el: circle, tween: tween });
    });
  }

  start() {}

  scrollHandler() {
    const sh = window.innerHeight;
    if (this.chunk8Text && !this.chunk8Text.classList.contains('show')) {
      if (this.chunk8Text.getBoundingClientRect().top <= sh - 100) {
        this.chunk8Text.classList.add('show');
        this.pack.playRandomPop(
          this.chunk8TextItemAll,
          this.chunk8TextItemCircleAll,
          this.chunk8TextItemChildAll
        );

        this.chunk8Text2.classList.add('show');
      }
    }

    if (this.circleAnimations.length > 0) {
      const rect = this.section4Dom.getBoundingClientRect();
      const isInView = rect.top < sh && rect.bottom > 0;

      this.circleAnimations.forEach((obj) => {
        if (isInView) {
          obj.tween.play();
        } else {
          obj.tween.pause();
        }
      });
    }
  }

  executeResize() {
    super.executeResize();
    this.carousels.forEach(carousel => carousel.executeResize());
  }
}